import { GDPRSdk, PurposeConfig, MockGDPR , GDPRPromise} from "@ciaopeople/cp-shatsu/GDPR";
import { isTestHost } from "../../lib/utils/DomainNameUtils.js";


const isTest = isTestHost(window.document.location.host);
const alternativeMock = new MockGDPR(isTest ? PurposeConfig.FULL : PurposeConfig.NO);


export function getGDPR(): Promise<GDPRSdk> {
    return GDPRPromise(alternativeMock)
}